export default __webpack_public_path__ + "static/media/img3.019f7850.png";